define(
  'builderShowcaseReviewsStarFilterHandler',[],
  () => {
    'use strict';

    /**
    * Used to save the selected stars filter into local storage
    * @param {*} stars the selected category.
    */
    function saveStarsToLocalStorage(stars) {
      if (!localStorage) {
        return;
      }

      localStorage.setItem('selectedStars', stars);
    }

    /**
     * set stars listener
     * */
    function setStarsHandlerListener(event) {
      if (!event.target) {
        return;
      }

      let target = event.target;

      if (!event.target.dataset.rate) {
        target = target.closest('[data-component="filter-by-star"]');
      }

      if (!target) {
        return;
      }

      const stars = target.dataset.rate;
      saveStarsToLocalStorage(stars);
    }

    document.body.addEventListener('click', setStarsHandlerListener);
  }
);

